import React from 'react';
import { Editor, Frame, Element } from '@craftjs/core';
import { Box } from '@mui/material';
import { Text } from './editor/blocks/Text';
import { Button } from './editor/blocks/Button';
import { Image } from './editor/blocks/Image';
import { Container } from './editor/blocks/Container';

// Компонент для рендеринга страниц, созданных с помощью визуального редактора
export const PageRenderer = ({ content, editorType, blocks }) => {
  if (editorType === 'visual' && blocks) {
    // Рендерим страницу, созданную в визуальном редакторе
    return (
      <Editor
        resolver={{
          Text,
          Button,
          Image,
          Container,
        }}
        enabled={false} // Отключаем редактирование
      >
        <Frame data={blocks}>
          <Element canvas is={Container} />
        </Frame>
      </Editor>
    );
  }

  // Рендерим страницу, созданную в WYSIWYG редакторе
  return (
    <Box
      sx={{
        '& img': { maxWidth: '100%', height: 'auto' },
        '& h1, & h2, & h3, & h4, & h5, & h6': {
          marginTop: '1em',
          marginBottom: '0.5em',
          fontWeight: 'bold',
        },
        '& p': {
          marginBottom: '1em',
          lineHeight: 1.8,
        },
        '& ul, & ol': {
          marginLeft: '20px',
          marginBottom: '1em',
        },
        '& a': {
          color: '#00ACC1',
          textDecoration: 'underline',
        },
        '& blockquote': {
          borderLeft: '4px solid #00ACC1',
          paddingLeft: '16px',
          marginLeft: 0,
          fontStyle: 'italic',
          color: 'text.secondary',
        },
      }}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};
